// Country code mapping for flag rendering.
// Keys MUST match strings in /app/frontend/src/lib/nationalities.js exactly.
export const NATIONALITY_TO_ISO = {
    "Canada": "ca",
    "USA": "us",
    "United States": "us",
    "Sweden": "se",
    "Finland": "fi",
    "Czechia": "cz",
    "Switzerland": "ch",
    "Germany": "de",
    "Russia": "ru",
    "Slovakia": "sk",
    "Japan": "jp",
    "Hungary": "hu",
    "Denmark": "dk",
    "France": "fr",
    "Italy": "it",
    "Norway": "no",
    "Austria": "at",
    "Poland": "pl",
    "Latvia": "lv",
    "Netherlands": "nl",
    "China": "cn",
    "South Korea": "kr",
    "Australia": "au",
    "United Kingdom": "gb",
    "Ireland": "ie",
    "Spain": "es",
    "Belgium": "be",
    "Slovenia": "si",
    "Belarus": "by",
    "Ukraine": "ua",
    "Kazakhstan": "kz",
};

// Nationality → real-life 3-letter abbreviation (IIHF/IOC style). Used as the
// text fallback when a nationality has no Countries-registry entry (NEVER just
// the first 3 letters of the name).
export const NATIONALITY_TO_CODE3 = {
    "Canada": "CAN",
    "USA": "USA",
    "United States": "USA",
    "Sweden": "SWE",
    "Finland": "FIN",
    "Czechia": "CZE",
    "Czech Republic": "CZE",
    "Switzerland": "SUI",
    "Germany": "GER",
    "Russia": "RUS",
    "Slovakia": "SVK",
    "Japan": "JPN",
    "Hungary": "HUN",
    "Denmark": "DEN",
    "France": "FRA",
    "Italy": "ITA",
    "Norway": "NOR",
    "Austria": "AUT",
    "Poland": "POL",
    "Latvia": "LAT",
    "Netherlands": "NED",
    "China": "CHN",
    "South Korea": "KOR",
    "Australia": "AUS",
    "United Kingdom": "GBR",
    "Great Britain": "GBR",
    "Ireland": "IRL",
    "Spain": "ESP",
    "Belgium": "BEL",
    "Slovenia": "SLO",
    "Belarus": "BLR",
    "Ukraine": "UKR",
    "Kazakhstan": "KAZ",
};
